window.dataLayer = window.dataLayer || [];
var stj = typeof stj !== 'undefined' ? stj : {};

stj.tracking = stj.tracking || {};

stj.analytics = (function ($) {
    return {
        customDimensions: {
            carStatus: 55,
            benchmark: 56,
            offerCount: 58,
        },

        userID: null,

        utmParamsString: null,

        completeListName: 'general',
        recommendationListName: 'recommendation',

        init: function () {
            if (dataLayer && dataLayer.userID) {
                this.userID = dataLayer.userID;
            }
        },

        trackPageView: function (args) {
            this.setVirtPath(args);

            if (ApplicationProperties.get('external') === false) {
                dataLayer.push({ anonymizeIP: false });
            }
        },

        trackRemarketing: function (params) {
            dataLayer.push({
                event: 'fireRemarketingTag',
                google_tag_params: params,
            });
        },

        trackCriteo: function (params) {
            dataLayer.push({
                event: 'fireCriteoTag',
                criteo_tag_params: params,
            });
        },

        trackLogin: function (id) {
            if (!id) {
                return;
            }

            this.userID = id;

            dataLayer.push({
                userID: this.userID,
            });
        },

        trackEvent: function (args, virtPath, customDimensions) {
            var eventData = {
                event: 'gaEvent',
                eventCategory: args[0],
                eventAction: args[1],
                eventLabel: args[2],
                eventValue: args[3],
                nonInteraction: args[4] || true,
            };
            if (virtPath) {
                eventData.virtPath = virtPath;
            }
            if (customDimensions) {
                for (var dimensionName in customDimensions) {
                    if (customDimensions.hasOwnProperty(dimensionName)) {
                        eventData[dimensionName] =
                            customDimensions[dimensionName];
                    }
                }
            }
            dataLayer.push(eventData);
        },

        trackCustomDimension: function (number, value) {
            var customDimension = {};
            customDimension['dimension' + number] = value;
            dataLayer.push(customDimension);
        },

        setVirtPath: function (args) {
            if (this.utmParamsString) {
                var virtPath = args.split('?');
                dataLayer.push({
                    virtPath: virtPath[0] + '?' + this.utmParamsString,
                });
            } else {
                dataLayer.push({ virtPath: args });
            }
        },

        trackCampaign: function (args) {
            this.utmParamsString = args[0];
            if (typeof virtPath !== 'undefined') {
                this.setVirtPath(virtPath);
            }
        },

        /**
         *
         * @param id
         * @param sku
         * @param name
         * @param category
         * @param price
         * @param quantity
         * @returns {*}
         */
        addItems: function (id, sku, name, category, price, quantity) {
            return {
                id: id,
                sku: sku,
                name: name,
                category: category,
                price: parseFloat(price) || 0.0,
                quantity: quantity,
            };
        },

        /**
         *
         * @param id
         * @param affiliation
         * @param revenue
         * @param tax
         * @param shipping
         * @returns {*}
         */
        addTransaction: function (id, affiliation, revenue, tax, shipping) {
            return {
                id: id,
                affiliation: affiliation,
                revenue: parseFloat(revenue) || 0.0,
                tax: parseFloat(tax) || 0.0,
                shipping: parseFloat(shipping) || 0.0,
            };
        },

        trackTransaction: function (addTransaction, addItem) {
            var transaction = this.addTransaction.apply(null, addTransaction);
            var item = this.addItems.apply(null, addItem);

            dataLayer.push({
                transactionId: transaction.id,
                transactionAffiliation: transaction.affiliation,
                transactionTotal: parseFloat(transaction.revenue.toFixed(2)),
                transactionTax: parseFloat(transaction.tax.toFixed(2)),
                transactionShipping: parseFloat(
                    transaction.shipping.toFixed(2)
                ),
                transactionProducts: [
                    {
                        sku: item.sku,
                        name: item.name,
                        category: item.category,
                        price: parseFloat(item.price.toFixed(2)),
                        quantity: item.quantity,
                    },
                ],
            });

            this.trackEnhancedEcommerceTransaction(transaction, item);
        },

        checkoutSteps: {
            'booking/confirmation': 2,
        },

        trackCheckoutStep: function () {
            var offer = $('.car-offer');
            var offerProperties =
                stj.checkout.tracking.getOfferProperties(offer);
            var product = stj.checkout.tracking.getBaseOffer(offerProperties);

            var checkoutStep =
                this.checkoutSteps[ApplicationProperties.get('gridId')] || 0;
            var isBestOffer =
                stj.global.getLocalStorage('selectedOfferIsBestOffer') ===
                'true';

            var list = isBestOffer
                ? this.recommendationListName
                : this.completeListName;
            this.trackEnhancedEcommerce('EECcheckout', {
                checkout: {
                    actionField: {
                        step: checkoutStep,
                        list: list,
                    },
                    products: [product],
                },
            });

            stj.analytics.trackOfferView(offerProperties.carID);
        },

        trackEnhancedEcommerce: function (event, data, virtPath) {
            var eventData = {
                event: event,
                ecommerce: data,
            };
            if (virtPath) {
                eventData.virtPath = virtPath;
            }
            dataLayer.push(eventData);
        },

        trackEnhancedEcommerceTransaction: function (transaction, item) {
            var offer = $('.carInformation');
            var offerProperties =
                stj.checkout.tracking.getOfferProperties(offer);

            var isBestOffer =
                stj.global.getLocalStorage('selectedOfferIsBestOffer') ===
                'true';
            var list = isBestOffer
                ? this.recommendationListName
                : this.completeListName;

            var product = stj.checkout.tracking.getBaseOffer(offerProperties);

            product.price = item.price;
            product.category = item.category;
            product.quantity = item.quantity;
            product.name = item.sku;

            var purchase = {
                actionField: {
                    id: transaction.id,
                    unique_identifier: offerProperties.bookingUniqueIdentifier,
                    affiliation: transaction.affiliation,
                    revenue: transaction.revenue,
                    tax: transaction.tax,
                    shipping: transaction.shipping,
                    coupon: offerProperties.couponCode,
                    list: list,
                    dimensions55: offerProperties.carStatus,
                },
                products: [product],
            };

            if (offerProperties.benchmark) {
                purchase.actionField.dimensions56 = offerProperties.benchmark;
            }

            this.trackEnhancedEcommerce('EECpurchase', {
                purchase: purchase,
            });
        },

        trackOfferView: function (carId) {
            if (!carId) {
                return;
            }

            var numOfOffers = this.getNumOfOffers(carId);
            this.trackCustomDimension(
                this.customDimensions.offerCount,
                numOfOffers
            );
        },

        getNumOfOffers: function (carId) {
            if (!carId) {
                return;
            }

            var quoteIdentifier = stj.global.getQueryParam('quoteIdentifier');

            var offersSeen =
                JSON.parse(stj.global.getLocalStorage('offersSeen')) || {};

            if (typeof offersSeen[quoteIdentifier] === 'undefined') {
                offersSeen[quoteIdentifier] = [];
            }

            if (offersSeen[quoteIdentifier].indexOf(carId) === -1) {
                offersSeen[quoteIdentifier].push(carId);
                stj.global.setLocalStorage(
                    'offersSeen',
                    JSON.stringify(offersSeen)
                );
            }

            return offersSeen[quoteIdentifier].length;
        },

        trackOptimizelyEvent: function (eventName, tags) {
            window.optimizely = window.optimizely || [];
            window.optimizely.push({
                type: 'event',
                eventName: eventName,
                tags: tags || {},
            });
        },

        trackOptimizelyEventWithValue: function (eventName, value) {
            this.trackOptimizelyEvent(eventName, { value: value });
        },

        trackOptimizelyEventWithRevenue: function (eventName, revenue) {
            this.trackOptimizelyEvent(eventName, { revenue: revenue });
        },
    };
})(jQuery);

stj.analytics.init();
